/* Header scroll */
(function(){
  var h = document.querySelector('.header-wrapper');
  if (!h) return;
  window.addEventListener('scroll', function(){ h.classList.toggle('scrolled', window.scrollY > 50); }, {passive: true});
})();

/* Mobile menu */
(function(){
  var btn = document.querySelector('.header__menu-toggle');
  var menu = document.querySelector('.mobile-menu');
  var close = document.querySelector('.mobile-menu__close');
  if (!btn || !menu) return;
  btn.addEventListener('click', function(){ menu.classList.add('active'); document.body.style.overflow = 'hidden'; });
  function shut(){ menu.classList.remove('active'); document.body.style.overflow = ''; }
  if (close) close.addEventListener('click', shut);
  menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', shut); });
})();

/* FAQ accordion */
document.querySelectorAll('.faq__question').forEach(function(btn){
  btn.addEventListener('click', function(){
    var item = btn.closest('.faq__item');
    var isOpen = item.classList.contains('active');
    document.querySelectorAll('.faq__item').forEach(function(i){ i.classList.remove('active'); });
    if (!isOpen) item.classList.add('active');
  });
});

/* Cart drawer */
(function(){
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-drawer-overlay');
  var closeBtn = document.querySelector('.cart-drawer__close');
  function openCart(){ if(drawer) drawer.classList.add('active'); if(overlay) overlay.classList.add('active'); document.body.style.overflow='hidden'; }
  function closeCart(){ if(drawer) drawer.classList.remove('active'); if(overlay) overlay.classList.remove('active'); document.body.style.overflow=''; }
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', openCart); });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
})();

/* Scroll reveal */
(function(){
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); } });
  }, {threshold: 0.08, rootMargin: '0px 0px -30px 0px'});
  els.forEach(function(el){ obs.observe(el); });
})();

/* ============================================
   PRODUCT IMAGE GALLERY — CRITICAL FIX
   Shopify image_tag outputs srcset attribute.
   Browsers prioritize srcset over src.
   Must remove srcset when swapping images.
   ============================================ */
(function(){
  var galleries = document.querySelectorAll('.featured-product__gallery');
  galleries.forEach(function(gallery){
    var mainImg = gallery.querySelector('.featured-product__main-image img');
    var thumbs = gallery.querySelectorAll('.featured-product__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        thumbs.forEach(function(t){ t.classList.remove('active'); });
        thumb.classList.add('active');

        var newSrc = thumb.getAttribute('data-full-src');
        if (!newSrc) return;

        /* Remove srcset so browser uses src */
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');

        /* Fade transition */
        mainImg.style.opacity = '0';
        setTimeout(function(){
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 150);
      });
    });
  });
})();

/* Quantity selector — updates display AND hidden form field */
document.querySelectorAll('[data-qty-minus]').forEach(function(b){
  b.addEventListener('click', function(){
    var v = b.parentElement.querySelector('.featured-product__qty-value');
    var n = parseInt(v.textContent);
    if(n > 1){ v.textContent = n - 1; }
    var hiddenQty = document.getElementById('fp-add-qty');
    if(hiddenQty) hiddenQty.value = parseInt(v.textContent);
  });
});
document.querySelectorAll('[data-qty-plus]').forEach(function(b){
  b.addEventListener('click', function(){
    var v = b.parentElement.querySelector('.featured-product__qty-value');
    v.textContent = parseInt(v.textContent) + 1;
    var hiddenQty = document.getElementById('fp-add-qty');
    if(hiddenQty) hiddenQty.value = parseInt(v.textContent);
  });
});
